import React from "react";
import Modal from "../../../../../_components/Modal";
import Text from "../../../../../_components/Text";
import Button from "../../../../../_components/Button";

import { getCookieByName, setCookieByName } from "../../../../../utils";

import AppContext from "../../../context";

import { dontGetAccounting } from "../../../../../api/branches/accounting";

const COOKIE_NAME = "Paul_Mercier_RE4";

export default (props) => {
  const [show, setShow] = React.useState();
  const context = React.useContext(AppContext);

  function onHide() {
    setCookieByName(COOKIE_NAME, "https://www.residentevil.com/re4/pt-br/");
    setShow(false);
  }

  function dontDont() {
    dontGetAccounting(context.currentBranch.id).then(onHide);
  }

  function yesGo() {
    dontGetAccounting(context.currentBranch.id).then(() => {
      onHide();
      window.location.href = "/accounting/?yes=GO!";
    });
  }

  function init() {
    if (context.currentBranch) {
      const notIsMei = context.currentBranch.branch_type != 3;
      const getAccountant = context.currentBranch.get_accountant == true;
      const cookie = !getCookieByName(COOKIE_NAME)
      const path = window.location.pathname != "/accounting/"

      const open = notIsMei && getAccountant && cookie && path;

      setShow(open);
    }
  }

  React.useEffect(init, [context.currentBranch]);
  return (
    <div>
      <Modal
        show={show}
        title="Ajude seu Contador e se ajude também!"
        onHide={onHide}
      >
        <div className="container">
          <div className="row">
            <Text color="primary" className="py-3">
              Estamos ajudando contadores a receber relatórios automáticos e a
              calcular seus impostos de forma fácil e eficiente. Cadastre seu
              contador na base e em breve receba novidades no seu EASYGESTOR!
            </Text>
            <div className="d-flex">
              <Button onClick={yesGo}>Sim</Button>
              <Button onClick={onHide} className="ml-5">
                Depois
              </Button>
            </div>
          </div>
          <div className="row py-3">
            <div className="d-flex">
              <Button onClick={dontDont} as="text" className="text-danger">
                Não quero cadastrar.
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/Accounting/PopUpModal/index.jsx